<template>
  <div
    class="file-box"
  >
    {{file.name}}
    <button
      @click="() => removeCallback(file)"
    >
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    file: Object,
    removeCallback: Function,
  },
};
</script>

<style lang="scss" scoped>
  .file-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e4e4e4;
    padding: 5px;
    margin: 5px 0;
    width: 80%;
    border-radius: 5px;

    button {
      box-shadow: none;
      border: none;
      background-color: transparent;
    }
  }
</style>